import React from "react";
import { message } from "antd";
import { CloseOutlined } from "@ant-design/icons";

let autoKey = 0;

const ClosableContent = ({ content, messageKey }) => (
  <span style={{ display: "inline-flex", alignItems: "center", gap: 12 }}>
    <span>{content}</span>
    <CloseOutlined
      style={{ cursor: "pointer", fontSize: 12, opacity: 0.65 }}
      onClick={() => message.destroy(messageKey)}
    />
  </span>
);

const showClosableMessage = ({
  type = "info",
  content,
  key,
  duration = 3,
  ...rest
}) => {
  autoKey += 1;
  const messageKey = key || `closable-message-${autoKey}`;

  message[type]({
    ...rest,
    key: messageKey,
    duration,
    content: <ClosableContent content={content} messageKey={messageKey} />,
  });

  return () => message.destroy(messageKey);
};

const closableInfo = (options) =>
  showClosableMessage({ ...options, type: "info" });

const closableSuccess = (options) =>
  showClosableMessage({ ...options, type: "success" });

const closableWarning = (options) =>
  showClosableMessage({ ...options, type: "warning" });

const closableError = (options) =>
  showClosableMessage({ ...options, type: "error" });

export {
  showClosableMessage,
  closableInfo,
  closableSuccess,
  closableWarning,
  closableError,
};

export default showClosableMessage;
